<template>
    <b-modal
        :id="modalId"
        :ref="modalId"
        title-tag="h2"
        :title="capitalize(modalAction) + ' Action'"
        :lazy="true"
        footer-class="d-flex justify-content-between"
        no-close-on-backdrop
        no-close-on-esc
    >
        <b-alert show variant="warning" v-if="warningMessage">
            <i class="cus-error"></i>
            <span id="dialog-alert-message">
                {{ warningMessage }}
            </span>
        </b-alert>
        <Action-Form
            ref="action-form"
            module="TEMPLATE_ACTION"
            :edited="editedAction"
            :add-new="addNew"
            @reset-warning="warningMessage = null"
            @loading="
                loading => {
                    dataLoading = loading;
                }
            "
            @disable-save="value => (isSaveDisable = value)"
        />

        <div slot="modal-footer" class="justify-content-between w-100">
            <b-button
                class="float-left"
                variant="secondary"
                @click="close"
                v-if="!dataLoading"
            >
                Cancel
            </b-button>

            <div class="float-right">
                <Loader v-if="saveLoading || dataLoading" :margin="2" />
                <b-button-group v-else>
                    <b-dropdown
                        v-if="addNew"
                        @click="save(true)"
                        left
                        split
                        text="Save + Add New"
                        variant="primary"
                    >
                        <b-dropdown-item @click="save(false)"
                            >Save + Done</b-dropdown-item
                        >
                    </b-dropdown>
                    <b-dropdown
                        v-else
                        @click="save(false)"
                        left
                        split
                        text="Save + Done"
                        variant="primary"
                    >
                        <b-dropdown-item @click="save(true)"
                            >Save + Add New</b-dropdown-item
                        >
                    </b-dropdown>
                </b-button-group>
            </div>
        </div>
    </b-modal>
</template>

<script type="text/javascript">
/**
 * @name CreateUpdateInvoiceTemplateItemAction
 * @description modal to create or update item action
 * @see apps/assets/js/module/inventory/action.js
 * @see apps/application/controllers/inventory/actions.php
 * @see apps/application/views/staff/business/template/sub/navbar.php
 * @see apps/application/views/staff/inventory/item/sub/action/bundle/create_update.php
 */

import ACTIONS from "@/constants/actions";
import TEMPLATES from "@/constants/templates";
import TEMPLATE_SERVICES from "@/services/templates";
import CustomRulesVeeValidate from "@/mixins/custom-rules-veevalidate";

const ACTION_NEW = "new";
const ACTION_EDIT = "edit";

export default {
    mixins: [CustomRulesVeeValidate],
    components: {
        Loader: () => import("@/module/commons/loader.vue"),
        ActionForm: () => import("@/components/item-actions/action-form.vue")
    },
    props: {},
    computed: {
        isNew() {
            return this.modalAction == ACTION_NEW;
        },
        modalAction() {
            return this.editedAction == null ? ACTION_NEW : ACTION_EDIT;
        },
        templateId() {
            return this.$store.state.settingsTemplate.templateId;
        }
    },
    mounted() {},
    data() {
        return {
            ACTIONS: ACTIONS,
            modalId: "bundleCreateUpdateModal",
            dataLoading: false,
            saveLoading: false,
            editedAction: null,
            addNew: false,
            warningMessage: null
        };
    },
    methods: {
        async open(editedAction = null) {
            this.dataLoading = true;
            this.warningMessage = null;
            this.editedAction = editedAction;
            this.$refs[this.modalId].show();
        },
        async save(addNew) {
            this.saveLoading = true;

            const isActionFormValid = await this.$refs[
                "action-form"
            ].checkFormIsValid();

            if (!isActionFormValid) {
                this.saveLoading = false;
                return false;
            }

            let params = this.$refs["action-form"].generateParams();
            if (this.modalAction == ACTION_EDIT) {
                params.template_action_id = this.editedAction.id;
            }
            try {
                let response;

                response = await TEMPLATE_SERVICES.addAction(
                    this.templateId,
                    params
                );

                if (response.code == 200) {
                    this.warningMessage = null;
                    this._message(response.message);
                    this.$emit("refresh");

                    if (addNew) {
                        this.addNew = addNew;
                        this.editedAction = null;
                        this.$refs["action-form"].resetAddNew();
                    } else {
                        this.close();
                    }
                }

                if (response.code == 400) {
                    this.warningMessage = response.message;
                }
            } catch (error) {
                this._message(error, "danger");
            } finally {
                this.saveLoading = false;
            }
        },
        close() {
            this.warningMessage = null;
            this.$refs[this.modalId].hide();
        }
    }
};
</script>
